export default __webpack_public_path__ + "static/media/32-icon-arrowDown.8141b4c6.svg";